import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Toast, ToasterService } from 'angular2-toaster';
import { ConfigService } from 'src/app/services/config.service';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-login-old',
  templateUrl: './login-old.component.html',
  styleUrls: ['./login-old.component.scss']
})
export class LoginOldComponent implements OnInit {
  
    countryCode: any = [];
    selectedCountryCode: any;
    url: string;
    phoneNum : any = null ;
    configJsonObj: any =[];
    cdnURL: string;
  
    constructor(private router:Router, public http: HttpClient, private route: ActivatedRoute, private config: ConfigService, private loginService:LoginService, public toasterService:ToasterService) {
      this.http.get('assets/config.json').subscribe((res:any) => {
        //this.config.setConfigJson(res);
        localStorage.setItem("url", res.baseURL);
        localStorage.setItem("cdnURL", res.cdnURL);
        localStorage.setItem("appCode", res.appCode);
        localStorage.setItem("projectURL", res.projectURL);
        
        this.route.queryParams.subscribe(params => {
  
          if(params.tenantId){
            //localStorage.setItem("appCode", params.appCode);
          localStorage.setItem("tid", params.tenantId);
          localStorage.setItem('_tid', '_' + params.tenantId);
          localStorage.setItem("userIdFromURL", params.userId);
          localStorage.setItem("accessToken", params.access_Token);
          localStorage.setItem("mallCode", params.mallCode);
          if(params.redirectParam){
            localStorage.setItem("redirectParam", params.redirectParam);
            }else{
              localStorage.setItem("redirectParam", "");
            }
          
          }
  
          this.config.getLocalStorageData();
  
         this.url = this.config.baseUrl + '/ImagePath/' + this.config._tid ;
         //this.url = this.config.baseUrl + '/CDN/' + this.config._tid ;

      
         this.getConuntryData();
          if(params.code){
            this.loginWithSocial(params);
        }
          
         
          
         
        })
        //this.config.getLocalStorageData();
    });
      
      
      
  
     
        
        
     
    }
  
    ngOnInit() {
    // this.config.getLocalStorageData();
      
    }
  
    onlyNumber(evt) {
      
      //this.checkLength(evt.value.length);
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        return false;
      }
      return true;
    }
   
  
     /**To get Country codes */
     getConuntryData() {
      this.loginService.getCountryCode(this.constructor.name).subscribe(result => {
        console.log(result)
      if(result['message'].code == 0){
        this.countryCode = result['data']['Country_MsT'];
        this.countryCode.forEach(element => {
          element.country_TEL_Code = '+' + element.country_TEL_Code.toString();
          if(element.country_Name == 'India' || element.country_Name == 'INDIA'){
            this.selectedCountryCode = element ;
          }
        })
      }else{
        this.toasterService.pop('error', result['message'].message)
      }
        
        console.log(this.countryCode)
  
      })
  
    }
  
    loginWithOTP(e){
      console.log(this.selectedCountryCode)
      
      let result = e.validationGroup.validate();
  
      if(result.isValid){
        this.setItems();
        this.loginService.fetchOTP(this.phoneNum, this.selectedCountryCode.Id ,this.constructor.name).subscribe(result => {
          if(result["errorCode"] == 0){
            localStorage.setItem("twoFactor", result['twoFactor']);
            localStorage.setItem("userCode", result['userId']);
            this.router.navigate(['login-with-otp']);
          }else{
            this.toasterService.pop("error", result["errorMessage"])
          }
          // if(result['2008']){
          //   this.toasterService.pop("error", result['2008'])
          // }else if(result['2006']){
          //   this.toasterService.pop("error", result['2006'])
          // }else{
          //   //console.log(result)
          //   localStorage.setItem("twoFactor", result['twoFactor']);
          //   localStorage.setItem("userCode", result['userId']);
          //   this.router.navigate(['login-with-otp'])
          // }
        })
      }else{
        this.toasterService.pop("error", "Invalid Mobile Number!")
      }
     
     
    }
  
    loginWithPassword(e){
      //this.router.navigate(['login-with-password']);
      let result = e.validationGroup.validate();
      if(result.isValid){
        this.setItems();
       this.loginService.verifyMobile(this.phoneNum, this.selectedCountryCode.Id).subscribe(result => {
       //// console.log(result, result['data'].data[0])
        if(result["message"].code == 0){
          localStorage.setItem("partyEmail", result['data'].data[0].party_email);
          this.config.getLocalStorageData();
          this.router.navigate(['login-with-password'])
        }else if(result["message"].code == 1005){
          this.toasterService.pop("error", result["message"].message)
        }else{
          this.toasterService.pop("error", result["message"].message)
        }
      })
      }else{
        this.toasterService.pop("error", "Please provide Mobile Number!")
      }
      
      
    }
  
    setItems(){
      localStorage.setItem("mobileNumber", this.phoneNum);
      localStorage.setItem("countryCode", this.selectedCountryCode.Id);
      localStorage.setItem("countryTelCode", this.selectedCountryCode.country_TEL_Code);
    }
  
    loginWithSocial(params){
      console.log(params)
          this.loginService.socialLogin(params).subscribe(result => {
            let dobobj = {};
            let genderobj = {};
            if(result['data'].fusionAuthUserDetails['data'].birthDate != "" && result['data'].fusionAuthUserDetails['data'].birthDate != null && result['data'].fusionAuthUserDetails['data'].birthDate != 'null'){
              dobobj = {
                "dob" : result['data'].fusionAuthUserDetails['data'].birthDate
              }
              this.config.dobobj = dobobj;
            }
            if(result['data'].fusionAuthUserDetails['data'].userGender != "" && result['data'].fusionAuthUserDetails['data'].userGender != null && result['data'].fusionAuthUserDetails['data'].userGender != "null"){
              if(result['data'].fusionAuthUserDetails['data'].userGender == "1"){
                genderobj = {
                  "gender" : "male"
                }
              }else if(result['data'].fusionAuthUserDetails['data'].userGender == "0"){
                genderobj = {
                  "gender" : "female"
                }
              }else{
                genderobj = {
                  "gender" : "other"
                }
              }
             this.config.genderobj = genderobj;
            }
            console.log(genderobj, dobobj)
            if(result["message"].code == 200){
              console.log(result)
              //return;
              if(result['data'].fusionAuthUserDetails.mobilePhone ==  null){
                this.config.userDetails["email"] = result['data'].fusionAuthUserDetails.email;
                this.config.userDetails["userId"] = result['data'].wovvUserDetails.userId;
                this.config.userDetails["mobileNumber"] = result['data'].fusionAuthUserDetails.mobilePhone;
                this.config.userDetails["countryCode"] = result['data'].fusionAuthUserDetails.countryTelCode;
                console.log("user data", this.config.userDetails)
                this.router.navigate(['social-signin-register-number'])
              }
              let userDetails = {
                "userId": result['data'].wovvUserDetails.userId,
                "name": result['data'].fusionAuthUserDetails.fullName,
                "email": result['data'].fusionAuthUserDetails.email,
                "phone":result['data'].fusionAuthUserDetails.mobilePhone,
                "countryCode": result['data'].fusionAuthUserDetails.countryTelCode,
                "redirectParam": this.config.redirectParam ? this.config.redirectParam : "",
                 ...genderobj,
                 ...dobobj
              }
  
              console.log(userDetails)
              //set in userdetails config
            this.loginService.redirectURL(userDetails,this.constructor.name).subscribe(results => {
  
              if(results["message"].code == 200 || results["message"].code == 0  ){
                let redirectURL = results['data'].data.url
                window.location.href = redirectURL
              }else if(result["message"].code == 888){
                console.log("am here")
                this.toasterService.pop('error', "Please login after some time!!");
              }else{
              this.toasterService.pop("error", result["message"].message)
              }
            });
            }else if(result["message"].code == 1005){
              this.toasterService.pop("error", result["message"].message)
            }else{
              this.toasterService.pop("error", result["message"].message)
            }
          })
        }
      
        loginWithGoogle(e){
          localStorage.setItem("social", 'Google');
          window.location.href ='https://accounts.google.com/signin/oauth/oauthchooseaccount?client_id=145109136201-8q4srjnlm4b07s2k7c177937jbu9pmt5.apps.googleusercontent.com&state='+ this.config._tid+'%26isMobile=4%26user_App_ID='+ this.config.appCode+'%26branchCode='+ this.config.mallCode+'&redirect_uri='+ this.config.projectURL+'/fynd-login&response_type=code&scope=openid%20email%20profile&access_type=offline&prompt=consent'
        }
        loginWithApple(e){
          localStorage.setItem("social", 'Apple');
          // let purl = '';
          // if(this.config.projectURL == "http://localhost:5000"){
          //   purl = "http%3A%2F%2Flocalhost:5000";
          // }
          // if(this.config.projectURL == "https://wovvfyndsit.wovvtech.com"){
          //   purl = "http%3A%2F%2Flocalhost:5000";
          // }
          let params = 'client_id=bff87de9-fe1a-4404-9a72-f12d07343c44&code_challenge=&code_challenge_method=&metaData.device.name=macOS%20Chrome&metaData.device.type=BROWSER&nonce=&redirect_uri='+this.config.projectURL+'/fynd-login&response_mode=&response_type=code&scope=offline_access&state='+ this.config._tid+'%26isMobile%3D4%26user_App_ID%3D'+ this.config.appCode+'%26branchCode%3D'+ this.config.mallCode+'&tenantId=f48037c2-4901-11eb-abd6-020065359cb0&timezone=Asia%2FCalcutta&user_code=&identityProviderId=13d2a5db-7ef9-4d62-b909-0df58612e775'
          let encodedParms = btoa(params);
          console.log(encodedParms)
          window.location.href ='https://appleid.apple.com/auth/authorize?client_id=com.wovvtetch.oken.fusionauth&redirect_uri=https%3A%2F%2Fauthsit.wovvtech.com%2Foauth2%2Fcallback&response_type=code%20id_token&state='+encodedParms+'&scope=email%20name&response_mode=form_post&frame_id=539b3717-4897-4a6a-a642-41cfeae6dc41&m=11&v=1.5.4'
        }
  
  }